import styled from 'styled-components';

export const ProductListContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.horziontalCardView ? 'repeat(1,fr)' : 'repeat(2, 1fr)'};
  justify-content: space-between;

  @media (min-width: 720px) {
    justify-content: flex-start;
    grid-template-columns: repeat(4, 1fr);
    gap: ${(props) => (props.location == 'category' ? '20px' : '0')};
    margin-top: ${(props) => (props.location == 'category' ? '10px' : '0')};
  }
  padding: 8px 4px;
  a {
    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;
